import type { AspectRatio } from '@time-line/components/types';

export const PRODUCT_GALLERY_RATIO: AspectRatio = '4:5';
export const PRODUCT_GALLERY_RATIO_DECIMAL: number = 4 / 5;
